import React, { useState } from "react";
import {
  Button,
  DropdownMenuNew,
  DualIcon,
  FormFieldSet,
  InfoCircle,
  SmartTooltip,
  TableAdv,
} from "../../../../components";
import { mapTableRows } from "../../../../utils";
import { formatWords2 } from "../../../../utils/stringUtils";
import ScheduleCallModal from "./Modals/ScheduleCallModal";
import { Link } from "react-router-dom";


const AiRecruiterJobs = () => {

    const [scheduleCall,setScheduleCall]=useState();
    const JobPostingStatus = {
    // 1: "Draft",
    2: "Active",
    3: "On Hold",
    4: "Hold by Client",
    5: "Interview L1",
    6: "Interview L2",
    7: "Interview L3",
    8: "Priority",
    9: "Filled",
    10: "Closed",
    11: "Agreement Sent",
    12: "Agreement Accepted",
  };
  const statusOptions = Object.entries(JobPostingStatus).map(
    ([value, label]) => ({
      value: Number(value),
      label,
    }),
  );
  const colJobDetails = [
    {
      key: "icons",
      label: "",
      width: "min-w-[200px]! max-w-[350px]!",
      render: (row) => {
        const contactEmpty = row?.contact > 0;

        return (
          <div className="flex items-center gap-2">
            <div>
              <DropdownMenuNew
                MenuSection={
                  <div className="flex flex-col">
                    {/* {row?.canEdit && ( */}
                    <Button
                      title={"Edit"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-2"
                      // onClick={() => setEditModal(true)}
                      // onClick={() => {
                      //   setSelectedJobId(row?.uiid);
                      //   setEditModal(true);
                      // }}
                    />
                    {/* )} */}
                    <Button
                      title={"Publish"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-1"
                    />
                    <Button
                      title={"Schedule Interview"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-2"
                      //   onClick={() => setScheduleModal(true)}
                    />

                    <Button
                      title={"Compose Mail"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-2"
                      //   onClick={() => setIsModalOpen(true)}
                    />
                  </div>
                }
              >
                <Button
                  icon={"more_vert"}
                  variant="text"
                  type="icon"
                  size="sm"
                  color="black"
                />
              </DropdownMenuNew>
            </div>
            <div>
              <Button
                type="icon"
                icon={"contacts"}
                color={contactEmpty ? "success" : "gray-500"}
                variant="text"
              />
            </div>
            <div className={`w-3 h-3 rounded-full bg-success`}></div>
            <div className="flex items-center gap-2">
              {/* {row?.applications > 0 && ( */}

              <SmartTooltip description="Talent Match" noicon>
                <InfoCircle
                  color="invoiced"
                  colorDepth="100"
                  className="text-white"
                  value={row?.talentMatch}
                  prefix={"+"}
                  noBorder
                  size="xs"
                  // onClick={() => {
                  //   toggleAccordion(row.id, "applications");
                  //   handleFetchTalentMatch(row);
                  // }}
                />
              </SmartTooltip>

              {/* )} */}

              {/* {row?.shortlisted > 0 && ( */}

              <SmartTooltip description="Shortlisted" noicon>
                <InfoCircle
                  className="text-white"
                  value={row?.shortlisted}
                  prefix={"+"}
                  noBorder
                  size="xs"
                  // onClick={() => {
                  //   toggleAccordion(row.id, "shortlisted");
                  //   handleFetchSubmissions(row, "shortlisted");
                  // }}
                />
              </SmartTooltip>

              {/* )} */}
              {/* {row?.pipelined > 0 && ( */}

              <SmartTooltip description="Pipeline" noicon>
                <InfoCircle
                  color="gray"
                  colorDepth="800"
                  className="text-white"
                  value={row?.pipelined}
                  prefix={"+"}
                  noBorder
                  size="xs"
                  // onClick={() => {
                  //   toggleAccordion(row.id, "pipelined");
                  //   handleFetchSubmissions(row, "pipelined");
                  // }}
                />
              </SmartTooltip>

              {/* )} */}
              {/* {row?.submission > 0 && ( */}

              <SmartTooltip description="Submission" noicon>
                <InfoCircle
                  color="info"
                  className="text-white"
                  value={row?.submission}
                  prefix={"+"}
                  noBorder
                  size="xs"
                  // onClick={() => {
                  //   toggleAccordion(row.id, "submitted");
                  //   handleFetchSubmissions(row);
                  // }}
                />
              </SmartTooltip>

              {/* )} */}
            </div>
            {/* {row?.notes && row?.notes.length > 0 && ( */}
            <div>
              <DualIcon
                size="sm"
                badgeIconColor="bg-success"

                //   onClick={() => {
                //     const newSelected = [row?.id];
                //     setSelectedRows(newSelected);

                //     const ids = newSelected
                //       .map(
                //         (rId) =>
                //           initialJobs.find((job) => job?.id === rId)?.uiid,
                //       )
                //       .filter(Boolean);
                //     setJobPostIds(ids);

                //     setShowDataId([row?.id]);

                //     setShowSingleNotes(true);
                //     setIsNotePanelOpen(false);

                //     setNoteId(row?.uiid);

                //     handleFetchNotes(row);
                //   }}
              />
            </div>
            {/* )} */}
          </div>
        );
      },
    },
    {
      key: "code",
      label: "Job Code",

        render: (row) => (
          <Link
            to={`/ats/jobs/ai-job-details`}
            className="text-info"
            // state={{ uiid: row?.uiid }}
            // onClick={() => {
            //   sessionStorage.setItem("selectedJobUiid", row?.uiid);
            //   sessionStorage.setItem(
            //     "prevJobsPage",
            //     window.location.pathname + window.location.search,
            //   );
            // }}
          >
            {row?.code}
          </Link>

        ),
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[230px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
            description={row?.jobTitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.jobTitle}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "companyName",
      label: "Company Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
            description={row?.companyName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.companyName}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "jobLocation",
      label: "Job Location",
      render: (row) => (
        <SmartTooltip
            description={formatWords2(row?.jobLocation)}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{formatWords2(row?.jobLocation)}</div>
        </SmartTooltip>
      ),
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "jobStatus",
      label: "Job Status",
      width: "min-w-[200px]! max-w-[250px]!",
        render: (row) => {
      //     const lastStatus =
      //       row?.statusHistory && row?.statusHistory?.length > 0
      //         ? row?.statusHistory[row?.statusHistory?.length - 1]?.status
      //         : 2;
      //     const currentOption =
      //       statusOptions.find((opt) => opt.value === lastStatus) ||
      //       statusOptions.find((opt) => opt.value === 2);

          return (
            <div className="w-[180px] min-w-[160px]">
              <FormFieldSet
                type="select"
                noTitle
                size="sm"
                placeholder="Select"
                options={statusOptions}
                // value={currentOption}
                showSearch
                // onChange={(val) => handleStatusChange(opt, row)}
                // showButton
              />
            </div>
          );
      //   },
    }
},
    {
      key: "clientBill",
      label: "Client Bill",
      width: "min-w-[180px]! max-w-[220px]!",
    },
    {
      key: "payBill",
      label: "Pay Bill",
      width: "min-w-[180px]! max-w-[220px]!",
    },
    {
      key: "deliveryManager",
      label: "Delivery Manager",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "recruiter",
      label: "Recruiter",
      width: "min-w-[200px]! max-w-[250px]!",
      render:(row)=>(
        <div className="flex items-center gap-1">
        <Button type="icon" color="danger" variant="text" icon={"android"}/>
        {row.recruiter}
        </div>
      )
    },
    // {
    //   key: "recruiter",
    //   label: "Recruiter",
    //   width: "min-w-[200px]! max-w-[250px]!",
    //   //   render: (row) => {
    //   //     const recruiterData = recruiter[row?.uiid] || [];
    //   //     // console.log("recruiterData", recruiterData);
    //   //     const recruiterOption = recruiterData
    //   //       .filter((r) => r && r.uiid)
    //   //       .map((r) => ({
    //   //         label: r.firstName,
    //   //         value: `${r.firstName} ${r.lastName}-${r.uiid}`,
    //   //       }));

    //   //     return (
    //   //       <div className="w-[180px] min-w-[160px]">
    //   //         <FormFieldSet
    //   //           // type="AllRecruiters"
    //   //           type="select"
    //   //           placeholder="Select"
    //   //           noTitle
    //   //           size="sm"
    //   //           multiple
    //   //           showSearch
    //   //           options={allRecruiters}
    //   //           value={recruiterOption}
    //   //           onChange={(opt) => handleRecruiterChange(opt, row)}
    //   //         />
    //   //       </div>
    //   //     );
    //   //   },
    // },
    {
      key: "jobCreatedBy",
      label: "Job Created By",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "jobCreatedOn",
      label: "Job Created On",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
            description={row?.jobCreatedOn}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.jobCreatedOn}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "minSalary",
      label: "Min Salary",
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "maxSalary",
      label: "Max Salary",
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
        key:"actions",
        label:"Actions",
        render:(row)=>(
            <Button type="icon" color="black" variant="text" icon={"pending_actions"} onClick={()=>setScheduleCall(true)}/>
        )
    }
  ];
  const rows = Array.from({ length: 10 }, (_, i) => ({
    id: i + 1,
    contact: 10,
    talentMatch: 128,
    shortlisted: 9,
    pipelined: 2,
    submission: 1,
    code: "NESU-070725",
    jobTitle: "Frontend Developer",
    companyName: "Tektree Inc",
    jobLocation: "Hyderabad",
    jobStatus: "1",
    clientBill: "10000",
    payBill: "100000",
    deliveryManager: "Chandan",
    recruiter: "AI Bot Recruiter",
    jobCreatedBy: "James",
    jobCreatedOn: "10 Mar, 2025 14:22:48 PM",
    minSalary: 500,
    maxSalary: 1000,
  }));

  const mappedRows = mapTableRows(rows, colJobDetails);

  return (
    <div className="flex flex-col mt-5 overflow-auto">
      <div className="flex flex-grow overflow-auto gap-4 mx-0.5">
        <TableAdv
          showCheckbox
          // singleSelection
          columns={colJobDetails}
          rows={mappedRows}
          //   defaultSelectedRows={showDataId}
          //   serverPagination={true}
          //   totalCount={totalCount}
          //   page={page}
          //   expandedRows={expandedRows}
          //   limit={limit}
          tableId={"BDMAIJobsTable"}
          //   onPaginationChange={setPage}
          //   onLimitChange={handleLimitChange}
          //   info={"info"}
          //   serverFiltering={true}
          //   onFilterChange={handleFilterChange}
          //   serverOnSearch={(key, value) => {
          //     setSearchValue(value);
          //     if (!value) {
          //       fetchAllJobs();
          //     }
          //   }}
          // tdClassName="!py-1"
          // accrodian={({ row, type }) => (
          //   <JobsAccordion row={row} type={type} />
          // )}
          // accrodian={({ row, type }) => {
          //   const submissionRows = accordionData[row.uiid] || [];
          //   return (
          //     <JobsAccordion
          //       rowData={submissionRows}
          //       type={type}
          //       loading={accordionLoading?.[row.uiid]}
          //     />
          //   );
          // }}
          //   accordion={(row, accordionType) => {
          //     const submissionRows = accordionData[row?.uiid] || [];
          //     return (
          //       <JobsAccordion
          //         rowData={submissionRows}
          //         type={accordionType}
          //         loading={accordionLoading?.[row?.uiid]}
          //         onStatusUpdate={handleSubmissionStatusUpdate}
          //       />
          //     );
          //   }}
          //   onSelectionChange={handleSelectionChange}
          toolbarRight={{
            search: true,
            filter: true,
            // add: selectedRows.length > 0 && [
            //   {
            //     component: (
            //       <Button
            //         title="Add Note"
            //         icon="add"
            //         size="sm"
            //         onClick={() => {
            //           setShowDataId([...selectedRows]);
            //           setIsNotePanelOpen(true);
            //         }}
            //       />
            //     ),
            //   },
            // ],
          }}
        />
      </div>
      <ScheduleCallModal isOpen={scheduleCall} onClose={()=>setScheduleCall(false)}/>
    </div>
  );
};

export default AiRecruiterJobs;
